// Role definitions with color mapping
const ROLE_DATA = [
    { id: 1, name: 'Player', color: 'primary' },
    { id: 2, name: 'Club Admin', color: 'secondary' },
    { id: 21, name: 'Coach', color: 'info' },
    { id: 3, name: 'Recruiter Admin', color: 'warning' },
    { id: 31, name: 'Recruiter', color: 'warning' },
    { id: 100, name: 'Admin', color: 'error' },
];

// Status definitions with color mapping
const STATUS_DATA = [
    { id: 0, name: 'Default', color: 'default' },
    { id: 1, name: 'Update Profile', color: 'warning' },
    { id: 9, name: 'Activate', color: 'success' },
];

// Gender definitions
const GENDER_DATA = [
    { id: 0, name: 'Female' },
    { id: 1, name: 'Male' },
    { id: 2, name: 'Female' },
];

// VIP definitions
const VIP_DATA = [
    { id: 0, name: 'FREE' },
    { id: 1, name: 'VIP' },
    { id: 2, name: 'PREMIUM' },
];

// Trial definitions
const TRIAL_DATA = [
    { id: 0, name: 'No' },
    { id: 9, name: 'Trial' },
];

// Source definitions
const SOURCE_DATA = [
    { id: 0, name: 'User Add' },
    { id: 1, name: 'Kivoai' },
    { id: 2, name: 'Google' },
    { id: 3, name: 'Apple' },
];

// Export choices for SelectInput components
export const ROLE_CHOICES = ROLE_DATA.map(({ id, name }) => ({ id, name }));
export const STATUS_CHOICES = STATUS_DATA.map(({ id, name }) => ({ id, name }));
export const GENDER_CHOICES = GENDER_DATA;
export const VIP_CHOICES = VIP_DATA;
export const TRIAL_CHOICES = TRIAL_DATA;
export const SOURCE_CHOICES = SOURCE_DATA;

// Export maps for Field components
export const ROLE_MAP: { [key: number]: { label: string; color: string } } = 
    Object.fromEntries(ROLE_DATA.map(({ id, name, color }) => [id, { label: name, color }]));

export const STATUS_MAP: { [key: number]: { label: string; color: string } } = 
    Object.fromEntries(STATUS_DATA.map(({ id, name, color }) => [id, { label: name, color }]));

export const GENDER_MAP: { [key: number]: string } = 
    Object.fromEntries(GENDER_DATA.map(({ id, name }) => [id, name]));

export const SOURCE_MAP: { [key: number]: string } = 
    Object.fromEntries(SOURCE_DATA.map(({ id, name }) => [id, name]));
